// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.squareToggleComponent {
  position: relative;
  display: flex;
  width: 323px;
  height: 52px;
  background-color: #f6f6f7;
  border-radius: 8px;
  flex-direction: row;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
}
.squareToggleComponent .leftToggle,
.squareToggleComponent .rightToggle {
  text-align: center;
  width: 158px;
  height: 46.43px;
  padding: 15px;
  top: 2.5px;
  position: relative;
  left: 3px;
  color: #868686;
  cursor: pointer;
}
.squareToggleComponent .selected {
  background-color: white;
  width: 158px;
  height: 46.43px;
  border-radius: 8px; /* card ui */
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  color: #505054;
}`, "",{"version":3,"sources":["webpack://./src/screens/workSchedule/toggleButton/toggleButton.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AACJ;AACI;;EAEI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AACR;AAEI;EACI,uBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA,EAAA,YAAA;EACA,4CAAA;EACA,cAAA;AAAR","sourcesContent":[".squareToggleComponent {\n    position: relative;\n    display: flex;\n    width: 323px;\n    height: 52px;\n    background-color: #f6f6f7;\n    border-radius: 8px;\n    flex-direction: row;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n\n    .leftToggle,\n    .rightToggle {\n        text-align: center;\n        width: 158px;\n        height: 46.43px;\n        padding: 15px;\n        top: 2.5px;\n        position: relative;\n        left: 3px;\n        color: #868686;\n        cursor: pointer;\n    }\n\n    .selected {\n        background-color: white;\n        width: 158px;\n        height: 46.43px;\n        border-radius: 8px; /* card ui */\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        color: #505054;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
